/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Booking_CutoffInputs */

const en_admin_resource_form_booking_cutoff = /** @type {(inputs: Admin_Resource_Form_Booking_CutoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booking cutoff`)
};

const de_admin_resource_form_booking_cutoff = /** @type {(inputs: Admin_Resource_Form_Booking_CutoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorbuchzeit`)
};

const es_admin_resource_form_booking_cutoff = /** @type {(inputs: Admin_Resource_Form_Booking_CutoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-reserva`)
};

const fr_admin_resource_form_booking_cutoff = /** @type {(inputs: Admin_Resource_Form_Booking_CutoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-réservation`)
};

const nl_admin_resource_form_booking_cutoff = /** @type {(inputs: Admin_Resource_Form_Booking_CutoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserveringsdeadline`)
};

/** @type {(inputs: Admin_Resource_Form_Booking_CutoffInputs) => LocalizedString} */
const it_admin_resource_form_booking_cutoff = en_admin_resource_form_booking_cutoff;

/** @type {(inputs: Admin_Resource_Form_Booking_CutoffInputs) => LocalizedString} */
const pt_br2_admin_resource_form_booking_cutoff = en_admin_resource_form_booking_cutoff;

/** @type {(inputs: Admin_Resource_Form_Booking_CutoffInputs) => LocalizedString} */
const pl_admin_resource_form_booking_cutoff = en_admin_resource_form_booking_cutoff;

/** @type {(inputs: Admin_Resource_Form_Booking_CutoffInputs) => LocalizedString} */
const hu_admin_resource_form_booking_cutoff = en_admin_resource_form_booking_cutoff;

/** @type {(inputs: Admin_Resource_Form_Booking_CutoffInputs) => LocalizedString} */
const ro_admin_resource_form_booking_cutoff = en_admin_resource_form_booking_cutoff;

/**
* | output |
* | --- |
* | "Booking cutoff" |
*
* @param {Admin_Resource_Form_Booking_CutoffInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_booking_cutoff = /** @type {((inputs?: Admin_Resource_Form_Booking_CutoffInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Booking_CutoffInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_booking_cutoff(inputs)
	if (locale === "de") return de_admin_resource_form_booking_cutoff(inputs)
	if (locale === "es") return es_admin_resource_form_booking_cutoff(inputs)
	if (locale === "fr") return fr_admin_resource_form_booking_cutoff(inputs)
	if (locale === "nl") return nl_admin_resource_form_booking_cutoff(inputs)
	if (locale === "it") return it_admin_resource_form_booking_cutoff(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_booking_cutoff(inputs)
	if (locale === "pl") return pl_admin_resource_form_booking_cutoff(inputs)
	if (locale === "hu") return hu_admin_resource_form_booking_cutoff(inputs)
	return ro_admin_resource_form_booking_cutoff(inputs)
});
export { admin_resource_form_booking_cutoff as "admin.resource_form.booking_cutoff" }